import { css } from 'styled-components';
import { IType } from './type.models';
import { getTypography } from '../../../utils';

export const type = css<IType>`
  ${({ t }) => (t ? getTypography(t) : '')}
`;

